<template>
<div>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="row">
      <div class="col-sm-12">
        <div id="resultsHeader">
          <div class="checkboxCol"></div>
          <div class="normalCol">Date</div>
          <div class="normalCol">Engineer</div>
          <div class="normalCol">Result</div>
          <div class="doubleCol">Further Work Required</div>
        </div>
      </div>
    </div>
    <div class="row" v-for="item in fgas" :key="item.id">
      
      <div class="col-sm-12">
        <div id="resultsBody">
          <div class="checkboxCol"></div>
          <div class="normalCol">{{ item.date | formatDate }}</div>
          <div class="normalCol">{{ item.engineer }}</div>
          <div class="normalCol">{{ item.result }}</div>
          <div class="doubleCol">{{ item.further }}</div>
          <div class="normalCol"><router-link :to="{name: 'AssetsLeakEdit', params: { id: item.asset_id, aid: item.id }}"><img src="@/assets/images/icon/edit.svg" width="17" border="0" /></router-link><img src="@/assets/images/icon/delete.svg" width="17" style="margin-left: 25px;" @click.prevent="deleteCheck(item.id)" /></div>
        </div>
      </div>
      
    </div>
  </div>
  <div class="paginationContainer">
    <div class="row">
      <div class="col-sm-12">
        <div align="right">
          Showing page {{ pagination.current_page }} of {{ pagination.last_page }} <a class="btnPaginate" @click.prevent="getOrders(pagination.prev_page_url)">Previous</a> <a class="btnPaginate" @click.prevent="getOrders(pagination.next_page_url)">Next</a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      fgas: {},
      pagination: {}
    }
  },
  created () {
    this.getFgas()
  },
  methods: {
    getFgas (page) {
      
        page = `/api/assets/${this.$route.params.id}/leakcheck`
     
      axios
        .get(page)
        .then((res) => {
          this.fgas = res.data
          this.pagination = res.data
          
        })
    },
    deleteCheck (leakCheckID) {
      if(confirm("Do you really want to delete this leak check?")){
        axios
          .delete(`/api/fgas/leakcheck/`+leakCheckID+``)
          .then(response => (
            //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
            this.$toast.success("Leak check deleted", {}),
            //this.$router.push({ name: 'AssetsLeak', params: { id: this.$route.params.id } })
            this.getFgas()
          ))
          .catch(err => console.log(err))
          // .finally(() => this.loading = false)
      }
    },
  }
}
</script>
